import { Capacitor } from "@capacitor/core";
import { DatePicker } from "@capacitor-community/date-picker";

/**
 * iOS style options for the date picker.
 */
export interface DatePickerIosOptions {
  style?: "wheels" | "inline";
  locale?: string;
}

/**
 * Android options for the date picker.
 */
export interface DatePickerAndroidOptions {
  locale?: string;
}

/**
 * Options for presenting the date/time picker.
 */
export interface DatePickerOptions {
  mode: "date" | "time" | "dateAndTime";
  date?: string;
  doneText?: string;
  cancelText?: string;
  is24h?: boolean;
  timezone?: string;
  ios?: DatePickerIosOptions;
  android?: DatePickerAndroidOptions;
}

/**
 * Result from the date picker.
 */
export interface DatePickerResult {
  value?: string;
}

/**
 * Presents the native date/time picker.
 * On native platforms, shows the native date/time picker UI.
 * On web, throws an error as this is not supported.
 *
 * @param options - Options for the picker
 * @returns The selected date/time value or undefined if cancelled
 */
export async function presentDatePicker(options: DatePickerOptions): Promise<DatePickerResult> {
  if (!Capacitor.isNativePlatform()) {
    throw new Error("Date picker is only available on native platforms");
  }

  return await DatePicker.present(options);
}
